module.exports = __webpack_public_path__ + "img/DAVID_CANNON_17-rs.ff21df3c.jpg";